import React from 'react'
import styled from 'styled-components'
import ParseContent from '../shared/ParseContent'
import BoxDefault from './BoxDefault'

const DienstenGrid = styled.section`
  @media (max-width: 991.98px) {
    padding-bottom: 4rem;
  }

  @media (min-width: 992px) {
    padding-bottom: 8rem;
  }
`

const DienstIcon = styled(BoxDefault)`
  background: transparent;
  padding: 0;

  > div {
    background-color: #e5e5e5;
    padding: 1rem;
    color: #1c1c1c;

    h3 {
      font-size: 20px;
      font-weight: bold;
      padding-inline: 1rem;
    }
  }

  padding-inline: 1rem;

  img {
    height: 90px;
    width: auto;
    margin-bottom: 1rem;
  }

  &:after {
    right: 0;
    bottom: 0;
    border-top-width: 50px;
    border-right-width: 50px;
  }

  max-width: 300px;
  margin: 0 auto;

  aspect-ratio: 1/1;
`

const ServiceContent = styled.div`
  font-size: ${(props) => props.theme.font.size.sm};

  > div {
    max-width: 75ch;
  }

  & p {
    line-height: ${(props) => props.theme.font.size.l};
    margin-bottom: 0;
  }

  & p > strong {
    color: #d50021;
    font-size: 20px;
    display: block;
    margin-bottom: 0.5rem;
  }

  & h3 {
    text-transform: uppercase;
    font-weight: bold;
    font-family: ${(props) => props.theme.font.family.secondary};
    font-size: 50px;
    margin-bottom: 0;
  }

  & ul {
    margin-bottom: 0;
  }

  @media (min-width: 992px) {
    > div {
      padding-inline: 3rem;
    }
  }

  & p {
    text-align: justify;
  }
`

const Title = styled.h3`
  @media (max-width: 400px) {
    font-size: 16px !important;
  }
`

function ServicesGrid({ services }) {
  return (
    <DienstenGrid>
      <div className="container pt-lg-5">
        {services.map((edge, index) => {
          const odd = index % 2 === 0
          return (
            <div
              className={`align-items-center row mb-5 ${
                odd ? '' : 'flex-row-reverse'
              }`}
            >
              <div className="col-sm-6 col-lg-3 h-100 mb-lg-0 mb-4">
                <DienstIcon className="">
                  <div className="d-flex flex-column justify-content-center h-100 align-items-center">
                    <img src={edge.icon.localFile.publicURL} alt="" />
                    <Title className="text-center">
                      <ParseContent content={edge.title} />
                    </Title>
                  </div>
                </DienstIcon>
              </div>
              <ServiceContent
                className={`col-sm-6 col-lg-9 d-flex ${
                  odd ? '' : 'justify-content-center pl-lg-5'
                }`}
              >
                <div>
                  <h3>{edge.title}</h3>
                  <ParseContent content={edge.description} />
                </div>
              </ServiceContent>
            </div>
          )
        })}
      </div>
    </DienstenGrid>
  )
}

export default ServicesGrid
